export default __webpack_public_path__ + "static/media/hide.a668e6b8.png";